var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.count > 0)?_c('i',{staticClass:"msg",on:{"click":function($event){return _vm.toMessage()}}},[_vm._v(_vm._s(_vm.count))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }